
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns":"http://www.w3.org/2000/svg","viewBox":"-17.582 -4.664 71.571 87.246"}, attrs),
              ...rest,
            },
            children.concat([_c('use',{attrs:{"xlink:href":"#a","stroke":"#003893","stroke-width":"5.165"}}),_c('path',{attrs:{"id":"a","d":"M-15 37.574h60L-15 0v80h60l-60-60z","fill":"#DC143C"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M-11.95 23.483a12.84 12.84 0 0023.9 0 11.95 11.95 0 01-23.9 0"}}),_c('g',{attrs:{"transform":"translate(0 29.045) scale(5.56106)"}},[_c('circle',{attrs:{"r":"1"}}),_c('g',{attrs:{"id":"d"}},[_c('g',{attrs:{"id":"c"}},[_c('path',{attrs:{"id":"b","d":"M.195-.98L0-1.39l-.195.408","transform":"rotate(11.25)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(22.5)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(45)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(67.5)"}})]),_c('use',{attrs:{"xlink:href":"#d","transform":"scale(-1 1)"}})]),_c('g',{attrs:{"transform":"matrix(8.1434 0 0 8.1434 0 58.787)"}},[_c('circle',{attrs:{"r":"1"}}),_c('g',{attrs:{"id":"g"}},[_c('g',{attrs:{"id":"f"}},[_c('path',{attrs:{"id":"e","d":"M.259.966L0 1.576l-.259-.61"}}),_c('use',{attrs:{"xlink:href":"#e","transform":"rotate(180)"}})]),_c('use',{attrs:{"xlink:href":"#f","transform":"rotate(90)"}})]),_c('use',{attrs:{"xlink:href":"#g","transform":"rotate(30)"}}),_c('use',{attrs:{"xlink:href":"#g","transform":"rotate(60)"}})])])])
          )
        }
      }
    